import portrait from "./portrait";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  portrait,
};
